'use client';

import { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { roomInviteUrl } from './room-invite';

export function RoomInviteQr({ roomCode }: { roomCode: string }) {
  const [inviteUrl, setInviteUrl] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setInviteUrl(roomInviteUrl(roomCode, window.location.origin));
  }, [roomCode]);

  async function copyInviteLink() {
    if (!inviteUrl) return;
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  }

  return (
    <section aria-label="Room invitation" className="room-invite">
      <div className="room-invite-code">
        <h1 className="room-code">{roomCode}</h1>
        <button
          aria-label={copied ? 'Invite link copied' : 'Copy invite link'}
          className="room-invite-copy"
          disabled={!inviteUrl}
          onClick={copyInviteLink}
          title={copied ? 'Invite link copied' : 'Copy invite link'}
          type="button"
        >
          {copied ? (
            <span aria-hidden="true">&#10003;</span>
          ) : (
            <svg aria-hidden="true" viewBox="0 0 24 24">
              <rect height="12" rx="2" width="12" x="8" y="8" />
              <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
            </svg>
          )}
        </button>
      </div>
      <div className="room-invite-qr">
        {inviteUrl ? (
          <QRCodeSVG
            aria-label={`QR code to join room ${roomCode}`}
            bgColor="#ffffff"
            fgColor="#17242b"
            level="M"
            role="img"
            size={176}
            value={inviteUrl}
          />
        ) : (
          <div aria-hidden="true" className="room-invite-qr-placeholder" />
        )}
      </div>
    </section>
  );
}
